/* eslint-disable array-callback-return */
import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { renderDurationSeo } from '@/utils/renderDuration';
import { convertMoney } from '@/utils/convertMoney';
import { style } from '@/styles/globals';

const mapping: { [key: string]: any } = {
  distance: 'Khoảng cách',
  average_duration: 'Thời gian di chuyển',
  average_flight_count: 'Số chuyến',
  airlines: 'Hãng hàng không',
  lowest_price: 'Giá vé một chiều rẻ nhất',
  lowest_round_flight_price: 'Giá vé khứ hồi rẻ nhất',
  average_price: 'Giá vé trung bình',
};

export default function ListDetail({
  dataObj, airlines, isDesktop, company,
}: any) {
  const newData: any = {};
  Object.keys(dataObj || {}).map(() => {
    newData.distance = `${dataObj.distance || 0}km`;
    newData.average_duration = renderDurationSeo(dataObj.average_duration);
    newData.airlines = company === 'pacific-airlines' ? 'Pacific Airlines' : (airlines || []).join(', ');
    newData.average_flight_count = `${Math.round(
      dataObj.average_flight_count || 0,
    )} chuyến / ngày`;
    newData.lowest_price = convertMoney(dataObj.lowest_price);
    newData.lowest_round_flight_price = convertMoney(
      dataObj.lowest_round_flight_price,
    );
    newData.average_price = convertMoney(dataObj.average_price);
  });

  return (
    <List
      sx={{
        width: '100%',
        bgcolor: 'background.paper',
        overflow: 'hidden',
        padding: 0,
        mt: 1,
        boxShadow: isDesktop ? '0px 2px 10px rgb(7 65 57 / 15%)' : 'none',
        borderRadius: isDesktop ? '6px' : 0,
      }}
    >
      {Object.keys(newData).map((key, i) => (
        <ListItem
          key={key}
          sx={{
            backgroundColor: i % 2 ? '#FFFFFF' : '#F9F9F9',
          }}
        >
          <ListItemText
            sx={{ width: '60%' }}
            primary={mapping[key]}
          />
          <ListItemText
            sx={{
              width: '40%',
              '& .MuiTypography-root': {
                ...style.text.content.regular,
                color: style.color.black2,
              },
            }}
            primary={newData[key]}
          />
        </ListItem>
      ))}
    </List>
  );
}
